import React from 'react';
import {connect} from 'react-redux';
import {getApartments} from "../../redux/apartment-reducer";
import Loader from "react-loader-spinner";
import ApartmentItem from "./ApartmentItem";
import './apartment-container.css'

class ApartmentContainer extends React.Component {

    componentDidMount() {
        this.props.getApartments(this.props.apartments);
    };

    render() {
        return (
            <>
                <section className="featured-properties-area section-padding-100-50">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="section-heading wow fadeInUp">
                                    <h2>Last added apartments</h2>
                                    <p>Last added apartments view.</p>
                                </div>
                            </div>
                        </div>
                        {<Loader type="Bars" color="#20c453" height={50} width={50}
                                 visible={this.props.isVisibleLoader}/>}
                        <div className="row">
                            {this.props.apartments.map(value =>
                                <ApartmentItem data={value}/>
                            )}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


let mapStateToProps = (state) => {
    return {
        apartments: state.apartmentsPage.apartments,
        isVisibleLoader: state.apartmentsPage.isVisibleLoader
    }
};

export default connect(mapStateToProps,
    {
        getApartments
    })(ApartmentContainer)